import { Info } from 'lucide-react';
import { useEffect, useState } from 'react';

export default function OffHoursBanner({ offHours, vendor }) {
  const [isOffHours, setIsOffHours] = useState(false);

  useEffect(() => {
    // Check if vendor is currently in off hours
    const checkOffHours = () => {
      if (!offHours) return false;

      const now = new Date();
      const currentHours = now.getHours();
      const currentMinutes = now.getMinutes();
      const currentTime = currentHours * 60 + currentMinutes; // Convert to minutes for easier comparison

      const [startTime, endTime] = offHours.split('-').map((timeStr) => {
        const [hours, minutes] = timeStr.split(':').map(Number);
        return hours * 60 + minutes;
      });

      // Handle cases where off hours span across midnight
      if (startTime > endTime) {
        return currentTime >= startTime || currentTime <= endTime;
      } else {
        return currentTime >= startTime && currentTime <= endTime;
      }
    };

    // Initial check
    setIsOffHours(checkOffHours());

    // Set up interval to check every minute
    const intervalId = setInterval(() => {
      setIsOffHours(checkOffHours());
    }, 60000); // Check every minute

    return () => clearInterval(intervalId);
  }, [offHours]);

  //   if (!isOffHours) return null;

  return (
    <div className="bg-amber-50 border-b border-amber-200 px-4 py-3 text-amber-800 animate-fadeIn">
      <div className="flex items-start">
        <div className="group relative">
          <Info className="w-5 cursor-pointer h-5 mr-3 mt-1" />
          <p className="absolute bg-white border text-sm  border-gray-300 px-2 py-2 rounded-lg w-96 z-20 -top-16 group-hover:block duration-300 hidden left-3">
            The deliveries might be affected during the off hours of the vendor.
          </p>
        </div>
        <div>
          <p className="font-medium">Shop Timings : {offHours}</p>
        </div>
      </div>
    </div>
  );
}
